import { productionOrderConstants } from "../../constants";

export function productionOrders(state = {}, action) {
  switch (action.type) {
    // get all
    case productionOrderConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case productionOrderConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case productionOrderConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case productionOrderConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case productionOrderConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case productionOrderConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case productionOrderConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case productionOrderConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case productionOrderConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case productionOrderConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case productionOrderConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case productionOrderConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case productionOrderConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
